<template>
  <div>
    <notifications group="app" position="top right"/> <!-- notification -->
    <router-view></router-view>
  </div>
</template>

<script>
export default {};
</script>

<style>
@import url("assets/css/nprogress_loader.css");
@import url("assets/css/app.css");
</style>
